// If we go to the / route, we arrive here
window.location = '/eg/home';
